import type { ResultProps } from "antd";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";

/** 固定状态页变体 */
type StatusPageVariant = "forbidden" | "notFound";

/** 各状态页展示配置 */
const VARIANT_CONFIG: Record<
  StatusPageVariant,
  { status: ResultProps["status"]; title: string; subTitle: string }
> = {
  forbidden: { status: "403", title: "403", subTitle: "暂无访问权限" },
  notFound: { status: "404", title: "404", subTitle: "页面不存在" },
};

interface StatusPageProps {
  /** 状态页类型 */
  variant: StatusPageVariant;
}

/** 403 / 404 等固定状态页 */
const StatusPage = ({ variant }: StatusPageProps) => {
  const { status, title, subTitle } = VARIANT_CONFIG[variant];
  return (
    <Result
      status={status}
      title={title}
      subTitle={subTitle}
      extra={
        <Link to="/">
          <Button type="primary">返回首页</Button>
        </Link>
      }
    />
  );
};

/** 无权限访问时的 403 页 */
export const ForbiddenPage = () => <StatusPage variant="forbidden" />;

/** 应用内 404 页 */
export const NotFoundPage = () => <StatusPage variant="notFound" />;

interface PagePlaceholderProps {
  /** 页面标题 */
  title: string;
}

/** 迁移动期占位页，后续替换为真实业务页面 */
export const PagePlaceholder = ({ title }: PagePlaceholderProps) => (
  <Result status="info" title={title} subTitle="页面开发中" />
);
